import { Button } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserType } from '../utility/Redux/profile';

const DefultSetting = () => {
  const navigate = useNavigate();
  const masters = [
    {
      name: 'Company Master',
      path: '/company_master',
      userType: 'ADMIN',
    },
    {
      name: 'User Master',
      path: '/user_master',
      userType: 'MANAGER ADMIN',
    },
    {
      name: 'Message Setup Master',
      path: '/message_setup_master',
      userType: 'ADMIN',
    },
    {
      name: 'Change Default Setting',
      path: '/change_default_setting',
      userType: 'MANAGER ADMIN',
    },
    {
      name: 'Create Database',
      path: '/create_db',
      userType: 'ADMIN',
    },
    {
      name: 'Template Master',
      path: '',
      userType: 'ADMIN',

      onclick: () => {
        navigate('/template_master');
      },
    },
    {
      name: 'User Scope Master',
      path: '',
      userType: 'ADMIN MANAGER',
      onclick: () => {
        navigate('/user_scope_roles');
      },
    },
  ];

  const userType = useSelector(selectUserType);
  return (
    <div className="h-full p-4">
      <div className="grid max-sm:grid-cols-2 t:grid-cols-6 d:grid-cols-8 gap-2  ">
        {masters.map((e, i) => {
          if (e.userType.includes(userType)) {
            return (
              <Button
                key={i}
                onClick={() => {
                  if (e.path) {
                    navigate(e.path);
                  } else {
                    e.onclick();
                  }
                }}
                variant={'contained'}
                style={{
                  textTransform: 'none',
                  backgroundColor: 'transparent',
                  padding: '0px',
                  borderRadius: '7px',
                  overflow: 'hidden',
                }}
              >
                <div className="bg-[#E8E2DB] py-3 w-full text-brown">
                  {e.name}
                </div>
              </Button>
            );
          }
        })}
      </div>
    </div>
  );
};

export default DefultSetting;
